module.exports = __webpack_public_path__ + "media/images/wintak_civ_white_cord-e1492315062c70b503c67c45dd453f35.png";